import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class EmailListService {


  private readonly httpClient = inject(HttpClient);

  addToEmailList(email: string): Observable<void> {
    return this.httpClient.post<void>(`${environment.apiUrl}/api/public/email-list`, {email});
  }
}
